module.exports = __webpack_public_path__ + "img/convo-2-nl.c14ed542.jpg";